<template>
  <div class="w-2/12"></div>
  <div class="flex items-center justify-center w-8/12">
    <InlineSvg v-if="isShowLogo" :src="IrisLogoStandart" width="100" height="40" />
  </div>
  <UserAction class="w-2/12" />
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import IrisLogoStandart from '@/assets/svg/iris-logo-standard.svg'
// import BackAdvisor from '../BackAdvisor.vue'
import UserAction from '@/components/UserAction.vue'

export default {
  name: 'LeadClientHeader',
  components: {
    UserAction,
    // BackAdvisor
  },
  setup() {
    const route = useRoute()

    const isShowLogo = computed(() => {
      return route.name !== 'lead/dashboard'
    })
    let role = null
    let email = null
    let username = null

    try {
      const storedData = localStorage.getItem('role')
      if (storedData) {
        const parsedData = JSON.parse(storedData)
        role = parsedData?.globalComponents?.role
      }
    } catch (error) {
      console.error('Error parsing role data from localStorage:', error)
    }

    try {
      const storedTRCMData = localStorage.getItem('TRCMData')
      if (storedTRCMData) {
        const parsedTRCMData = JSON.parse(storedTRCMData)
        email = parsedTRCMData?.globalComponents?.TRCMData?.email
        if (email) {
          username = email.split('@')[0]
        }
      }
    } catch (error) {
      console.error('Error parsing TRCMData from localStorage:', error)
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'user_data_push',
      iris_user: username,
      iris_user_type: role,
    })
    return {
      isShowLogo,
      IrisLogoStandart,
    }
  },
}
</script>
